import React from 'react';
import './ChooseCoupons.less';
import autobind from 'autobind-decorator';
import { CouponsItem } from '../';
import { observer } from 'mobx-react';

interface chooseCouponsState {
    current: number;
    navList: any[];
}

interface chooseCouponsPropType {
    prefixCls?: string;
    onHandleClose?: any;
    list?: any[];
    onCheckBoxClick?: (id) => void;
    onUseClick?: () => void;
    onTabClick?: (index) => void;
    price: number;
    current: number;
}

@observer
class ChooseCoupons extends React.Component<chooseCouponsPropType, chooseCouponsState> {
    static defaultProps = {
        prefixCls: 'chooseCoupons',
    };

    state = {
        current: 0, // tab切换索引
        navList: ['可用优惠券', '不可用优惠券'],
    };

    @autobind
    onTabClick(current) {
        if (this.props.onTabClick && this.state.current !== current) {
            this.props.onTabClick(current)
        }
        this.setState({current});
    }

    @autobind
    onCheckBoxClick(id) {
        if (this.props.onCheckBoxClick) {
            this.props.onCheckBoxClick(id);
        }
    }

    render() {
        const {prefixCls, onHandleClose, list = [], onUseClick, price, current} = this.props;
        const {navList} = this.state;
        return (
            <div>
                <div className={`${prefixCls}-cover`}/>
                <div className={`${prefixCls}-container`}>
                    <div className={`${prefixCls}-close`} onClick={onHandleClose}/>
                    <div className={`${prefixCls}-title`}>选择优惠券</div>
                    <div className={`${prefixCls}-navBox`}>
                        {
                            navList.map((item, index) => {
                                return (
                                    <p key={index} className={current === index ? 'active' : ''} onClick={() => {
                                        this.onTabClick(index);
                                    }}>{item}</p>
                                );
                            })
                        }
                    </div>
                    <div className={`${prefixCls}-item-box`} style={current === 0 ? {} : {height: '81.5%'}}>
                        {
                            list.map((value: any) => {
                                return (
                                    <div className={value.useType === 1 && current === 1 ? `${prefixCls}-item-context clearfix` : ``}>
                                        <CouponsItem
                                            key={value.templateId}
                                            data={value}
                                            text={''}
                                            imgBg={current === 0 ? '可用' : '不可用'}
                                            isCheckedBox={current === 0}
                                            onCheckBoxClick={this.onCheckBoxClick}
                                            style={value.useType === 1 && current === 1 ? {margin: 0} : {}}
                                        />
                                        {
                                            value.useType === 1 && current === 1 && (
                                                <div className={`${prefixCls}-item-noMsg`}>
                                                    当前订单还差<i>{(value.useLimit * 100 - price * 100) / 100}</i>元可以使用
                                                </div>
                                            )
                                        }
                                    </div>
                                );
                            })
                        }
                        {
                            list.length === 0 && (
                                <div className={`${prefixCls}-empty`}>
                                    <p>当前还没有优惠券哦~</p>
                                    {/* <p>去首页去找商品发现惊喜吧！</p> */}
                                </div>
                            )
                        }
                    </div>
                    {current === 0 && <div className={`${prefixCls}-use-btn`} onClick={onUseClick}>使用</div>}
                </div>
            </div>

        );
    }
}

export default ChooseCoupons;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/chooseCoupons/ChooseCoupons.tsx